export default __webpack_public_path__ + "static/media/SizingTwo.e5805420.png";